import moment from "moment";
import classNames from "classnames";
// React
import React from "react";
// Helpers
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateDisplay from "common/ui/components/datePicker/DateDisplay";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./DatePicker.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class DatePicker extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { onSelect, isDisabled, allowCustomRanges, dateLimit, minDate, maxDate, fromDate, toDate, ranges } = this.props;
        let className = this.props.className ? this.props.className : "";
        //-- Convert display dates to strings
        let extras = {};
        if (fromDate && toDate) {
            extras = {
                startDate: moment(fromDate),
                endDate: moment(toDate)
            };
        }
        //-- Handle event
        const handleEvent = (event, picker) => {
            if (picker.startDate.format("DD MMMM YYYY") !== picker.oldStartDate.format("DD MMMM YYYY") ||
                picker.endDate.format("DD MMMM YYYY") !== picker.oldEndDate.format("DD MMMM YYYY")) {
                onSelect(picker.startDate, picker.endDate);
            }
        };
        if (isDisabled) {
            return (React.createElement("div", { className: classNames(styles.datePicker, styles.disabled, "disabled", className) },
                React.createElement(DateDisplay, { fromDate: fromDate, toDate: toDate })));
        }
        return (React.createElement(DateRangePicker, Object.assign({}, extras, { autoUpdateInput: false, opens: "left", minDate: minDate, maxDate: maxDate, maxSpan: dateLimit, showDropdowns: false, showWeekNumbers: false, linkedCalendars: true, ranges: ranges, alwaysShowCalendars: false, showCustomRangeLabel: allowCustomRanges, autoApply: !allowCustomRanges, applyButtonClasses: classNames(styles.datePicker, className), onApply: (x, y) => handleEvent(x, y) }),
            React.createElement(DateDisplay, { fromDate: fromDate, toDate: toDate })));
    }
}
